import React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import { images, showNotification, truncateText } from "../../../../constants";
import { updateAlbum } from "../../hooks/AlbumsHooks";
import { useAlbumsContext } from "../../../../providers/OrganizationAdmin/AlbumProvider";
import { Toast } from "../../../../common/alert";
import moment from "moment";
import StatusDropdown from "../../../../common/StatusDropdown";
import { useAuth } from "../../../../hooks";

const TableRowSection = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleImagePreviewModalOpen,
  handleNavigateToDetails,
  setSelectedImage,
  columnWidths,
}) => {
  const { currentUser } = useAuth();

  const { handleGetAllAlbums, loading, setLoading } = useAlbumsContext();
  // console.log("albus", row);
  const handleUpdateAlbumStatus = async (privacy) => {
    try {
      setLoading(true);
      let dataTemp = {
        privacy: privacy,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      console.log(privacy, row.id);
      let responseTemp = await updateAlbum(row.id, dataTemp);
      console.log("update album response:", responseTemp);
      await handleGetAllAlbums();
      showNotification("Album updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating album", error.message);
    } finally {
      setLoading(false);
    }
  };

  const dropdownOptions = ["public", "private", "unlisted"];

  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        scope="row"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.title || 200,
          minWidth: columnWidths?.title || 200,
          maxWidth: columnWidths?.title || 200,
        }}
      >
        {row?.title && truncateText(row?.title, 20)}
      </TableCell>
      {/* <TableCell
        align="center"
        style={{ border: "1px solid #BABABA" }}
        onClick={() => {
          setSelectedImage(row?.photoUrl);
          handleImagePreviewModalOpen();
        }}
      >
        <img
          src={row?.photoUrl}
          alt="empty image"
          style={{ width: 45, height: 40 }}
        />
      </TableCell> */}
      <TableCell
        align="center"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.photo || 120,
          minWidth: columnWidths?.photo || 120,
          maxWidth: columnWidths?.photo || 120,
        }}
        onClick={() => {
          setSelectedImage(
            row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo
          );
          handleImagePreviewModalOpen();
        }}
      >
        {
          <img
            src={row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo}
            alt="empty image"
            style={{ width: 45, height: 40 }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = ""; // Set the source to an empty string or a placeholder image URL
            }}
          />
        }
      </TableCell>

      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 120,
          minWidth: columnWidths?.id || 120,
          maxWidth: columnWidths?.id || 120,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={row?.id}
      >
        {row.id}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["userData.userName"] || 160,
          minWidth: columnWidths?.["userData.userName"] || 160,
          maxWidth: columnWidths?.["userData.userName"] || 160,
        }}
      >
        {row?.userData != null
          ? `${row?.userData?.firstName + " " + row?.userData?.lastName}`
          : row?.createdBy || ""} 
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.description || 190,
          minWidth: columnWidths?.description || 190,
          maxWidth: columnWidths?.description || 190,
          maxHeight: 48,
        }}
      >
        {row?.description && truncateText(row?.description, 20)}
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.privacy || 150,
          minWidth: columnWidths?.privacy || 150,
          maxWidth: columnWidths?.privacy || 150,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <StatusDropdown
          options={dropdownOptions}
          currentValue={row?.privacy}
          onChange={handleUpdateAlbumStatus}
        />
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 170,
          maxWidth: columnWidths?.createdAt || 170,
        }}
      >
        {/*date modified*/}
        {row?.createdAt &&
          moment.unix(row?.createdAt?.seconds).format("MM/DD/YYYY HH:mm:ss")}
      </TableCell>

      {/* <TableCell align="left" style={tableCellStyles}>
        {row.privacy}
        
      </TableCell>
      <TableCell align="left" style={tableCellStyles}>
        
        {row?.userData?.updatedAt &&
          moment.unix(row?.userData?.updatedAt.seconds).format("MM-DD-YYYY")}
      </TableCell> */}
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.quicktales || 170,
          minWidth: columnWidths?.quicktales || 170,
          maxWidth: columnWidths?.quicktales || 170,
        }}
      >
        {/* {row.noOfQTInAlbum} */}
        {row?.quicktales?.length}
      </TableCell>

      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.length || 100,
          minWidth: columnWidths?.length || 100,
          maxWidth: columnWidths?.length || 100,
        }}
      >
        {row?.audioLength}
      </TableCell>
    </TableRow>
  );
};

export default TableRowSection;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  // paddingLeft: 5,
  color: "#00A7CD",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
const tableStatusCellStyles = {
  border: "1px solid #BABABA",
  cursor: "pointer",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};
